import { useAction } from "@reatom/npm-react";
import { AdaptivityProvider, AppRoot, ConfigProvider } from "@vkontakte/vkui";
import { useEffect } from "react";
import { HashRouter } from "react-router";
import { getCountryAction } from "./core/reatom/state/city/city";

import Modals from "./components/Modals/Modals";
import { Popout } from "./components/Popout/Popout";
import { AppRoutes } from "./routes";
import { restoreInitData } from "@telegram-apps/sdk-react";
import { getOrdersAction } from "./core/reatom/state/orders/orders";
import useTheme from "./core/hooks/useTheme";

// // if (import.meta.env.MODE === "development") {
// import("eruda").then((eruda) => eruda.default.init());
// //   connectLogger(ctx);
// // }

function App() {
  const handleCountry = useAction(getCountryAction);
  const handleOrders = useAction(getOrdersAction);
  useEffect(() => {
    restoreInitData();
  }, []);
  useEffect(() => {
    handleCountry();
    handleOrders();
  }, []);

  const theme = useTheme();

  return (
    <ConfigProvider colorScheme={theme}>
      <AdaptivityProvider>
        <AppRoot>
          <HashRouter>
            <Popout /> <Modals />
            <AppRoutes />
          </HashRouter>
        </AppRoot>
      </AdaptivityProvider>
    </ConfigProvider>
  );
}

export default App;
